import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Separator } from '@/components/ui/separator';
import { useAuthenticationState } from '@/hooks/use-authentication';
import { isRoleAtLeast } from '@/lib/role';
import { SegmentedTabs } from '@/components/segmented-tabs';
export const Route = createFileRoute('/console/_authenticated/_layout/workspace/_layout')({
    component: LayoutPage,
});
function LayoutPage() {
    const { t } = useTranslation();
    const { workspace } = useAuthenticationState();
    const tabs = React.useMemo(() => [
        {
            label: t('information'),
            path: '/console/workspace',
            pathname: '/console/workspace',
        },
        {
            label: t('billing'),
            path: '/console/workspace/billing',
            pathname: '/console/workspace/billing',
            hide: !workspace?.role || !isRoleAtLeast(workspace.role, 'ADMIN'),
        },
    ], [t, workspace]);
    return (<div className="flex flex-col gap-6 px-4 py-6 md:px-8">
            <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                <div>
                    <div className="flex items-center gap-2" data-testid="workspace-title" aria-hidden="true">
                        <h1 className="text-2xl font-semibold tracking-tight">
                            {t('workspaces.title', { ns: 'glossary' })}
                        </h1>
                    </div>
                    <p className="text-sm text-muted-foreground">{t('workspaces.description', { ns: 'glossary' })}</p>
                </div>
            </div>

            <Separator />
            <div className="overflow-x-auto">
                <SegmentedTabs navItems={tabs} layoutId="workspace-tabs"/>
            </div>
            <Outlet />
        </div>);
}
